import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Alert } from 'reactstrap';
import Form from '../forms/Form';
import { getStatusBadgeColor, isNovertejumsEditableByUser, canDeleteNovertejums } from './riskaNovertejumsUtils';
import {
    loadRiskaNovertejums,
    advanceRiskaNovertejumaStatuss,
    riskaNovertejumuActions,
    riskaNovertejumuPamatinfoActions
} from '../../actions/dzeramaUdensSatecesBaseiniActions';

const getPamatinfoFormFieldCfgs = () => [
    {
        name: 'nosaukums',
        label: 'Nosaukums',
        required: true,
        renderClassName: 'bold'
    },
    {
        name: 'datums',
        label: 'Apstiprināšanas datums',
        editable: false,
        renderer: (val) => val ? new Date(val).toLocaleDateString('lv-LV') : '-'
    },
    {
        name: 'autors',
        label: 'Autors',
        editable: false
    },
    {
        name: 'statuss',
        label: 'Statuss',
        editable: false,
        renderer: (val) => (
            <span className={`badge badge-${getStatusBadgeColor(val)}`}>
                {val}
            </span>
        )
    },
    {
        name: 'komentari',
        label: 'Komentāri',
        type: 'textarea',
        extraFieldProps: { rows: 3 }
    },
    {
        name: 'izveidots',
        label: 'Izveidots',
        editable: false,
        renderer: (val) => val ? new Date(val).toLocaleString('lv-LV') : ''
    },
    {
        name: 'atjaunots',
        label: 'Atjaunots',
        editable: false,
        renderer: (val) => val ? new Date(val).toLocaleString('lv-LV') : ''
    }
];

class RiskaNovertejumsPamatinfo extends Component {

    handleSave = (data) => {
        const { savePamatinfoAct, loadRiskaNovertejums, id } = this.props;
        const { parametri, geom, urbumi_snapshot, riska_objekti, ...dataToSave } = data;
        return savePamatinfoAct(dataToSave).then((result) => {
            loadRiskaNovertejums(id);
            return result;
        });
    }

    handleAdvanceStatus = () => {      // 'objekt' | 'kategorija' | null
        const { advanceRiskaNovertejumaStatuss, loadRiskaNovertejums, id } = this.props;
        advanceRiskaNovertejumaStatuss(id)
            .then(() => loadRiskaNovertejums(id));
    }

    handleArchive = () => {
        if (!window.confirm('Vai patiešām vēlaties arhivēt šo riska novērtējumu? Arhivētu novērtējumu vairs nevarēs labot.')) return;
        this.handleAdvanceStatus();
    }

    handleUnarchive = () => {
        if (!window.confirm('Vai patiešām vēlaties atjaunot šo riska novērtējumu no arhīva?')) return;
        this.handleAdvanceStatus();
    }

    render() {
        const { novertejums, riskaNovertejumiPamatinfo } = this.props;

        if (!novertejums) {
            return <Alert color="info">Nav datu</Alert>;
        }

        if (!this.pamatinfoFormFieldCfgs) {
            this.pamatinfoFormFieldCfgs = getPamatinfoFormFieldCfgs();
        }

        const { editable, submiting } = riskaNovertejumiPamatinfo || {};
        const isEditable = isNovertejumsEditableByUser(novertejums, this.props.user?.tiesibas);
        const canDelete = canDeleteNovertejums(novertejums, this.props.user?.tiesibas);

        const showStandaloneDelete = canDelete && !editable && !isEditable;
        const handleStandaloneDelete = () => {
            if (window.confirm('Vai patiešām vēlaties neatgriezeniski dzēst šo riska novērtējumu?')) {
                this.props.deleteAct();
            }
        };
        const deleteButton = showStandaloneDelete ? (
            <Button color="danger" onClick={handleStandaloneDelete} className="float-right">
                <i className="fa fa-trash-o"></i>&nbsp;&nbsp;Dzēst
            </Button>
        ) : null;

        return (
            <div className="form-container">
                <Form
                    editable={editable}
                    submiting={submiting}
                    dataObj={novertejums}
                    formFieldCfgs={this.pamatinfoFormFieldCfgs}
                    metadataFormCfg="riska_novertejumi_pamatinfo_view"
                    onSubmit={this.handleSave}
                    onReset={this.props.stopEditPamatinfoAct}
                    onStartEdit={isEditable ? this.props.startEditPamatinfoAct : null}
                    onDelete={canDelete ? this.props.deleteAct : null}
                    tiesibasLabot="SATECES_BASEINI_VERTETAJS"
                    extraElements={deleteButton}
                />

                {!editable && isEditable && novertejums.statuss === 'melnraksts' && (
                    <div className="mt-3">
                        <Button color="info" onClick={this.handleAdvanceStatus}>
                            Iesniegt pārskatīšanai
                        </Button>
                    </div>
                )}
                {!editable && isEditable && novertejums.statuss === 'pārskatīšanā' &&
                    this.props.user?.tiesibas?.includes('SATECES_BASEINI_VERTETAJS_EKSPERTS') && (
                    <div className="mt-3">
                        <Button color="success" onClick={this.handleAdvanceStatus}>
                            Apstiprināt
                        </Button>
                    </div>
                )}
                {!editable && novertejums.statuss === 'apstiprināts' &&
                    this.props.user?.tiesibas?.includes('SATECES_BASEINI_ARHIVET') && (
                    <div className="mt-3">
                        <Button color="dark" onClick={this.handleArchive}>
                            <i className="fa fa-archive"></i>&nbsp;&nbsp;Arhivēt
                        </Button>
                    </div>
                )}
                {!editable && novertejums.statuss === 'arhivēts' &&
                    this.props.user?.tiesibas?.includes('SATECES_BASEINI_ARHIVET') && (
                    <div className="mt-3">
                        <Button color="success" onClick={this.handleUnarchive}>
                            <i className="fa fa-undo"></i>&nbsp;&nbsp;Atjaunot no arhīva
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const riskaNovertejumi = state.riskaNovertejumi || {};
    return {
        novertejums: riskaNovertejumi.selectedItem,
        riskaNovertejumiPamatinfo: state.riskaNovertejumiPamatinfo || {},
        user: state.user || {},
    };
};

export default connect(mapStateToProps, {
    savePamatinfoAct: riskaNovertejumuPamatinfoActions.saveAct,
    startEditPamatinfoAct: riskaNovertejumuPamatinfoActions.startEditAct,
    stopEditPamatinfoAct: riskaNovertejumuPamatinfoActions.stopEditAct,
    deleteAct: riskaNovertejumuActions.deleteAct,
    advanceRiskaNovertejumaStatuss,
    loadRiskaNovertejums
})(RiskaNovertejumsPamatinfo);
